import { useQuery, UseQueryOptions } from 'react-query';
import { getPanelTemplate } from './api';
import { PanelTemplate } from './types';
import { useSelector } from 'react-redux';
import { getSelectedProjectId } from '@/reducers/ui/projectsUiReducer';

export default function usePanelTemplate(
  params: {
    templateId: string;
    revisionId?: string | null;
  },
  options?: UseQueryOptions<PanelTemplate>
) {
  const projectId = useSelector(getSelectedProjectId);
  const { templateId, revisionId } = params;
  const isEnabled = Boolean(projectId && templateId) && options?.enabled;

  return useQuery<PanelTemplate>(
    ['panelTemplate', { projectId, templateId, revisionId }],
    () => getPanelTemplate({ projectId, templateId, revisionId }),
    { ...options, enabled: isEnabled }
  );
}
